import { useAppDispatch } from "@/hooks";
import { setIsApiLoading } from "@/store/appSlice";
import apiClient from "@/utils/api";
import { yupResolver } from "@hookform/resolvers/yup";
import { Col, Form, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import * as yup from "yup";

const updatePasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required("元のパスワードが必須です")
    .min(8, "8文字以上入力してください"),
  newPassword: yup
    .string()
    .required("新規パスワードが必須です")
    .min(8, "8文字以上入力してください"),
  newPasswordConfirmation: yup
    .string()
    .required("新パスワードの確認が必須です")
    .oneOf([yup.ref("newPassword")], "新規パスワードが一致しません"),
});

const UpdatePassword = () => {
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(updatePasswordSchema),
  });

  const updatePassword = async (data) => {
    try {
      dispatch(setIsApiLoading(true));
      await apiClient.put(`password`, data);
      toast.success("パスワードが変更されました。");
    } catch (err) {
      setError("newPasswordConfirmation", {
        type: "server",
        message: err.response.data.message,
      });
      setError("password", {
        type: "server",
        message: "",
      });
      setError("newPassword", {
        type: "server",
        message: "",
      });
    } finally {
      dispatch(setIsApiLoading(false));
    }
  };

  return (
    <>
      <Helmet>
        <title>パスワード変更</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <Form onSubmit={handleSubmit(updatePassword)}>
                  <Form.Group as={Row} className="form-group">
                    <Form.Label column sm="4" md="2" className="d-flex align-items-center">
                      元のパスワード
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="10">
                      <Form.Control
                        type="password"
                        isInvalid={!!errors.password}
                        placeholder="元のパスワード"
                        {...register("password")}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password?.message}
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="form-group">
                    <Form.Label column sm="4" md="2" className="d-flex align-items-center">
                      新規パスワード
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="10">
                      <Form.Control
                        type="password"
                        isInvalid={!!errors.newPassword}
                        placeholder="新規パスワード"
                        {...register("newPassword")}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.newPassword?.message}
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="form-group">
                    <Form.Label column sm="6" md="2" className="d-flex align-items-center">
                      新パスワードの確認
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="10">
                      <Form.Control
                        type="password"
                        isInvalid={!!errors.newPasswordConfirmation}
                        placeholder="新パスワードの確認"
                        {...register("newPasswordConfirmation")}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.newPasswordConfirmation?.message}
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                  <div className="d-flex justify-content-center">
                    <button
                      type="submit"
                      className="btn btnStand btn_save btn-warning"
                    >
                      変更
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePassword;
